// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupHeader-module-popupHeader {
  background-color: var(--popup-background);
  padding: 15px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PopupHeader-module-popupHeader > button {
  box-shadow: none;
  padding: 0;
  width: 25px;
  height: 25px;
}

.PopupHeader-module-popupHeader > button > svg {
  width: 100%;
  height: 100%;
  fill: var(--text);
  object-fit: contain;
}

@media screen and (min-width: 380px) {

  .PopupHeader-module-popupHeader {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Popup/components/PopupHeader/PopupHeader.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;AAEF","sourcesContent":[".popupHeader {\r\n  background-color: var(--popup-background);\r\n  padding: 15px;\r\n  border-bottom: 1px solid var(--border);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.popupHeader > button {\r\n  box-shadow: none;\r\n  padding: 0;\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n\r\n.popupHeader > button > svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  fill: var(--text);\r\n  object-fit: contain;\r\n}\r\n\r\n@media screen and (min-width: 380px) {\r\n\r\n  .popupHeader {\r\n    border-top-left-radius: 5px;\r\n    border-top-right-radius: 5px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var popupHeader = `PopupHeader-module-popupHeader`;
export default ___CSS_LOADER_EXPORT___;
